<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">id</th>
        <th scope="col">data złożenia</th>
        <th scope="col">zamawiający</th>
        <th scope="col">netto</th>
        <th scope="col">vat</th>
        <th scope="col">brutto</th>
        <th scope="col">status</th>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="o in order.orders">
        <td>{{o.order_id}}</td>
        <td>{{o.added}}</td>
        <td>{{o.user_forname}} {{o.user_surname}}</td>
        <td>{{formatPrice(o.basket_net)}} zł</td>
        <td>{{formatPrice(o.basket_tax)}} zł</td>
        <td>{{formatPrice(o.basket_gross)}} zł</td>
        <td>{{o.status_name}}</td>
        <td>
          <button class="btn btn-primary" @click="repeateOrder(o)">Powtórz Zamówienie</button>
        </td>
        <td>
          <show-icon @click.native="goToOrder(o.order_id)" title="Pokaż szczegóły zamówienia"/>
        </td>
      </tr>
    </tbody>
  </table>
</template>


<script>
import ShowIcon from "vue-material-design-icons/magnify.vue";
import { mapState } from "vuex";

export default {
  components: {
    ShowIcon
  },
  props: ["limit", "offset"],
  computed: {
    ...mapState({
      order: state => state.order
    })
  },

  watch: {
    offset: function(value) {
      this.$store.dispatch("order/orderList", {
        limit: this.limit,
        offset: value
      });
    }
  },

  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    goToOrder(orderId) {
      this.$router.replace({ name: "orderPage", params: { orderId: orderId } });
    },
    async repeateOrder(data) {
      await this.$store.dispatch("order/getOrder", data.order_id)
      .then(data =>{
        this.$store.dispatch("basket/clearBasket")
        .then(()=>{
          let pom = data.position_list;
          pom.forEach(async (element) => {
            await this.$store.dispatch("basket/addToBasket",{id:element.variant_id,cart_quantity:element.quantity},false);
          });
          this.$store.dispatch('openRightWindow');        
        })
      })
    }
  },

  beforeMount() {
    this.$store.dispatch("order/orderList", {
      limit: this.limit,
      offset: this.offset
    });
  }
};
</script>



// WEBPACK FOOTER //
// node_modules/redbay-b2b-order/src/OrdersTable.vue